import React from "react"

import TwoColumnHeroWithImageRight, {
  CONTAINMENT_MODE,
} from "./_base/TwoColumnHeroWithImageRight"

import { parse } from "node-html-parser"

import ComponentFactory from "../components/parsers/ComponentFactory"

import * as heroSectionStyles from "../styles/HeroSection.module.css"

const backgroundImageParentNode = content => {
  if (!content) return null

  const root = parse(content.replace(/[\r\n]/gm, ""))
  if (!root.childNodes) return null

  return root.childNodes.filter(node =>
    node.classNames.trim().split(/\s+/).includes("cw-hero-block")
  )[0]
}

export default function HeroSection(props) {
  const { content } = props

  const contentWrapperProps = {
    className: "hero-section",
    pageContext: props.pageContext,
    modals: props.modals,
  }
  const components = ComponentFactory(content.innerHTML, contentWrapperProps)

  const imageParentNode = backgroundImageParentNode(content.innerHTML)

  return (
    <TwoColumnHeroWithImageRight
      contentClass={heroSectionStyles.content}
      imageHolder={imageParentNode}
      imageSelector={`hero-image`}
      imageClass={heroSectionStyles.backgroundImage}
      className={`${props.className} ${heroSectionStyles.wrapper}`}
      mode={CONTAINMENT_MODE.background}
    >
      <div>{components}</div>
    </TwoColumnHeroWithImageRight>
  )
}
